import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";
import useToastStore from "../../../../console/store/useToastStore";

interface OrderRequest {
    customer_idx: string;
    customer_name: string;
    order_name: string;
    order_mobile: string;
    product_idx: string;
    sales_amount: string;
    order_amount: string;
    wreath_sender: string;
    wreath_word: string;
    recipient_name: string;
    recipient_mobile: string;
    is_union: boolean;
    event_content_idx: string;
    related_person: string;
    work_location: string;
    department: string;
    company_tel: string;
    delivery_immediate: boolean;
    delivery_date: string;
    delivery_time: string;
    delivery_post: string;
    delivery_address: string;
    delivery_address_detail: string;
    delivery_memo_idx: string;
    delivery_memo: string;
    file_memo: string;
    customer_manager_idx?: number[] | null;
    order_memo: string;
    order_file?: File[];
    event_content?: string;
    customer_request?: string;
    product_quantity?: number;
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

const createFormData = (data: OrderRequest) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        let value = data[key as keyof OrderRequest];

        if (key === "order_file" && Array.isArray(value)) {
            value.forEach(file => {
                if (file instanceof File) {
                    formData.append("order_file", file);
                }
            });
            return;
        } else if (value !== undefined && value !== null && value !== "") {
            formData.append(key, value.toString());
        }
    });

    return formData;
};

export const usePostOrder = (successCallback?: (orderIdx: number) => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);
    const { addToast } = useToastStore();

    return useMutation({
        mutationFn: async (orderData: OrderRequest) => {
            const formData = createFormData(orderData);
            const response = await axios.post(enum_api_uri.post_order, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },
        onSuccess: response => {
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            successCallback?.(response.data.order_idx);

            const formattedMessage = response.message;
            addToast({
                message: formattedMessage,
                type: "notice",
                height: true,
            });
        },
    });
};
